<div class="modal-header">
    <h5 class="modal-title">Select Team</h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Close click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body change-event-dialog">
    <div class="ui-current-events">
        <div (click)="onNationalTeamSelect(nationalTeam)"
             *ngFor="let nationalTeam of nationalTeamsService?.nationalTeams"
             class="event-item gradient-overlay cursor-hand {{nationalTeam?.cssClass}}">
            <div class="row">
                <div class="col-12">
                    <h3>{{ nationalTeam?.name }}</h3>
                    <div class="event-date">{{nationalTeam?.calendarYear}} <span class="program">{{nationalTeam?.programGroupName}}</span></div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="nationalTeamsService?.pastNationalTeams.length > 0" class="ui-past-events">
        <h6><span>Past Events</span></h6>

        <div (click)="onNationalTeamSelect(nationalTeam)" *ngFor="let nationalTeam of nationalTeamsService?.pastNationalTeams"
             class="event-item gradient-overlay cursor-hand {{nationalTeam?.cssClass}}">
            <div class="row">
                <div class="col-12">
                    <h3>{{ nationalTeam?.name }}</h3>
                    <div class="event-date">{{nationalTeam?.calendarYear}} <span class="program">{{nationalTeam?.programGroupName}}</span></div>
                </div>
            </div>
        </div>
    </div>

</div>

<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">Close</button>
</div>